<template>
<div>

<ContentHeader title="Kullanıcı Bilgileri"  url="SupplierUsers" :show_button="true"  icon="arrow-left" buttontype="danger" label="Geri"></ContentHeader>
<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>


<template v-if="!loading">
<div class="mt-4">

<ClickEditInputText  title="Kullanıcı İsmi" :value="item.name" valkey="name" @dataChanged="dataChanged" />
<ClickEditInputText  title="Kullanıcı Email" :value="item.email" valkey="email" @dataChanged="dataChanged" />
<ClickEditInputText  title="Kullanıcı Telefon" :value="item.phone" valkey="phone" @dataChanged="dataChanged" />
<ClickEditInputText  title="Kullanıcı Görevi" :value="item.Position" valkey="Position" @dataChanged="dataChanged" />
<div class="grid">
<div class="col-3 md:col-2"><p class="click_edit_value_title">Kullanıcı Auth Sayfası:</p></div>
<div class="col-9 md:col-10">
  <template v-if="item.user.reset_string">
  <Button type="button"  
  icon="pi pi-copy"  
  class="p-button-primary p-button-outlined p-button-sm mt-3"  
  @click="copyLink(appurl+'/reset-password/'+item.user.reset_string)"
  v-tooltip.right="{ value: 'Kopyala', disabled: false,class: 'custom-top-tooltip' }"
   />
 </template>
   <template v-else>
    <p class="click_edit_value animate_class">Kullanıcı şifresini oluşturmuş</p>
  </template>
</div>

  </div>

</div>
</template>



</div>
</template>

<script>
export default {

  name: 'SupplierUser',

  data () {
    return {
       item:null,
      loading:true,
    }
  },
  computed:{
    appurl()
    {
      //return "https://api.verifyhub.io/"
      console.log("apihook")
      console.log(process.env.VUE_APP_APP_ROOT)
      let api =  process.env.VUE_APP_APP_ROOT
      return api
    },
  },
  mounted()
  {
    this.$store.dispatch('ui/setActiveTab',"yetkililer")
    this.getData()
  },
  methods:{
    copyLink(link)
    {
      navigator.clipboard.writeText(link);
    },
    async getData()
    {
      let item = await this.generalApiGetWithoutLoader("supplier/user/"+this.$route.params.user_id)
      await console.log(item);
      //item = await this.mapUserRoles(item)
      await console.log("data");
      this.item = await item
      await console.log(this.$route.params.id);
      this.loading = await false
    },
    mapUserRoles(user)
    {
      let arr = []
      for(let element of user.userroles)
      {
        element.id = element.name
        arr.push(element)
      }
      user.userroles = arr
      return user

    },
    dataChanged(data)
    {
      console.log(data.value)
      console.log(data.key)
      let formdata = new FormData()
      
      if(data.key=="userroles")
      {
        formdata.append(data.key,JSON.stringify(data.value))
      }
      else
      {
        formdata.append(data.key,data.value)
      }
      //return false
      this.generalSubmission(formdata,"supplier/user/"+this.item.id,this.afterdataChanged)
    },
    afterdataChanged(response)
    {
      console.log("data changed");
      console.log(response.data);
      //let item = this.mapUserRoles(response.data)
      this.item = response.data
      //this.$store.dispatch('users/setUser',this.item) 
      
    }
   
    
    
  }
};
</script>

<style lang="css" scoped>
</style>